import type { ReactNode } from 'react'
import { cx } from '../../cx'
import { Info, Warning } from '../../icons'
import styles from './InfoBanner.module.css'

export type InfoBannerTone = 'info' | 'warning' | 'danger'

export interface InfoBannerProps {
  tone?: InfoBannerTone
  title?: ReactNode
  children?: ReactNode
  className?: string
}

export function InfoBanner({ tone = 'info', title, children, className }: InfoBannerProps) {
  const IconComponent = tone === 'info' ? Info : Warning
  return (
    <div role="note" className={cx(styles.banner, styles[tone], className)}>
      <span className={styles.icon} aria-hidden="true">
        <IconComponent size={18} />
      </span>
      <div className={styles.body}>
        {title !== undefined ? <div className={styles.title}>{title}</div> : null}
        {children !== undefined ? <div className={styles.content}>{children}</div> : null}
      </div>
    </div>
  )
}
